<script>
import MainMenuView from '../../../shared/views/MainMenuView';
import ListAdvisoryCitiesView from '../lists/ListAdvisoryCitiesView';
import PermissionHelper from '../../../../core/shared/helpers/PermissionHelper';
import PageHeaderView from '../../../shared/views/PageHeaderView';

export default {
  components: {
    'page-header-view': PageHeaderView,
    'main-menu-view': MainMenuView,
    'list-advisory-cities-view': ListAdvisoryCitiesView,
  },
  data() {
    return {};
  },
  methods: {
    onCanShow(moduleName) {
      return PermissionHelper.canShow(moduleName);
    },
  },
};
</script>

<template>
  <div>
    <main-menu-view />
    <div class="wrapper">
      <div class="sa4d25">
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-12 col-lg-12">
              <div class="section3125">
                <page-header-view
                  icon="fas fa-city"
                  title="Ciudades de Asesoría"
                  subtitle="Plazas y centros de asesoría disponibles para agendar orientación"
                />
                <div class="la5lo1">
                  <list-advisory-cities-view />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>